








import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class NoteBox extends Vue {
  @Prop({ type: String, required: false, default: undefined })
  title: string | undefined;
}
